import { render, staticRenderFns } from "./ServiceHeader.vue?vue&type=template&id=3901dac2&scoped=true"
import script from "./ServiceHeader.vue?vue&type=script&lang=js"
export * from "./ServiceHeader.vue?vue&type=script&lang=js"
import style0 from "./ServiceHeader.vue?vue&type=style&index=0&id=3901dac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3901dac2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Heading: require('/vercel/path0/components/elements/Heading.vue').default,Medias: require('/vercel/path0/components/elements/Medias/index.vue').default,Section: require('/vercel/path0/components/elements/Section.vue').default})
